var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icons8-instagram","transform":"translate(-5 -5)"},[React.createElement("path",{"id":"Path_1","data-name":"Path 1","d":"M18.6,5H10.9A5.908,5.908,0,0,0,5,10.9v7.7a5.908,5.908,0,0,0,5.9,5.9h7.7a5.908,5.908,0,0,0,5.9-5.9V10.9A5.908,5.908,0,0,0,18.6,5ZM14.75,19.882a5.132,5.132,0,1,1,5.132-5.132A5.137,5.137,0,0,1,14.75,19.882Zm5.132-9.237a1.026,1.026,0,1,1,1.026-1.026A1.026,1.026,0,0,1,19.882,10.645Z","fill":"#81e6d9","key":0}),React.createElement("circle",{"id":"Ellipse_1","data-name":"Ellipse 1","cx":"4","cy":"4","r":"4","transform":"translate(11 11)","fill":"#81e6d9","key":1})]));
}

Instagram.defaultProps = {"width":"19.5","height":"19.5","viewBox":"0 0 19.5 19.5"};

module.exports = Instagram;

Instagram.default = Instagram;
